<template>
    <ColumnaIzquierda></ColumnaIzquierda>
    <EnviarNominas></EnviarNominas>
</template>
<script>
import ColumnaIzquierda from '../components/ColumnaIzquierda.vue';
import EnviarNominas from '../components/EnviarNominas.vue';
export default {
    name: 'HomeView',
    components: {
        ColumnaIzquierda,
        EnviarNominas,
    }
}
</script>